import { createApp } from 'vue'
import options from './FormAddressFieldGroup.options'

const el = '.kb-component--form-address-field-group'

export default function (Store) {
    const DOM = document.querySelectorAll(el)
    if (DOM.length) {
        DOM.forEach((FormAddressFieldGroupDOM) => {
            const template = FormAddressFieldGroupDOM.innerHTML
            options.template = template
            const component = createApp(options, {
                rootElement: FormAddressFieldGroupDOM
            }).use(Store)
            component.mount(FormAddressFieldGroupDOM)
        })
    }
}
